module.exports = __webpack_public_path__ + "img/bianca1.646a29f1.png";